import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            当前最受关注的热门话题与专题内容，发现更多精彩
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-300 ${
                item.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-100 border-background-200 hover:border-foreground-300'
              }`}
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                item.hot ? 'text-accent-700' : 'text-foreground-600'
              }`}>
                {item.name}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                item.hot ? 'text-accent-400' : 'text-foreground-400'
              }`}>
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}